import * as React from 'react';
import { useMemo } from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TagEditorProps, TagInputType } from '../../../typings/tagCloudTargeting';

import './TagEditor.css';
import { TagInputEditor } from './TagInputEditor/TagInputEditor';
import { TagSuggestEditor } from './TagSuggestEditor/TagSuggestEditor';
import { TagSuggestWithVersionEditor } from './TagSuggestWithVersionEditor/TagSuggestWithVersionEditor';

const BLOCK = 'tag-editor';

export const TagEditor: React.FC<TagEditorProps> = React.memo(props => {
    const {
        tagValue,
        onSubmit,
        onFocus,
        onCancel,
        onRefChange,
        onDelete,
        onPaste,
        inputType,
        index,
        suggestItems
    } = props;

    const tagInputControl = useMemo(() => {
        if (inputType === TagInputType.SUGGEST_WITH_VERSION && suggestItems) {
            return (
                <TagSuggestWithVersionEditor
                    tagValue={tagValue}
                    suggestItems={suggestItems}
                    index={index}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onPaste={onPaste}
                    onFocus={onFocus}
                    onRefChange={onRefChange}
                    onDelete={onDelete}
                />
            );
        }

        if (inputType === TagInputType.SUGGEST && suggestItems) {
            return (
                <TagSuggestEditor
                    tagValue={tagValue}
                    suggestItems={suggestItems}
                    index={index}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onPaste={onPaste}
                    onFocus={onFocus}
                    onRefChange={onRefChange}
                    onDelete={onDelete}
                />
            );
        }

        return (
            <TagInputEditor
                tagValue={tagValue}
                index={index}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onPaste={onPaste}
                onFocus={onFocus}
                onRefChange={onRefChange}
                onDelete={onDelete}
            />
        );
    }, [props]);

    return <div className={Bem.cls(BLOCK)}>{tagInputControl}</div>;
});
